import { useMutation } from '@tanstack/react-query'
import { addSubAdminParticipantsToGroup } from '..'

const useAddSubAdminParticipants = () =>
  useMutation({
    mutationFn: ({
      groupId,
      subAdminUserIds,
    }: {
      groupId: string
      subAdminUserIds: string[]
    }) => addSubAdminParticipantsToGroup(groupId, { subAdminUserIds }),
  })

export default useAddSubAdminParticipants
